import { ButtonGroup } from "@/components/buttonGroup/buttonGroup";
import { SimulatorParams } from "@/model/simulator.typing";
import { MapIcon } from "lucide-react";

const options = ["Béarn", "Beauce", "Bretagne Nord"];

export function LocationFilter({
  selected,
  setSelected,
}: {
  selected: SimulatorParams["localisation"];
  setSelected: (value: SimulatorParams["localisation"]) => void;
}) {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="flex flex-nowrap items-center gap-2 text-sm font-semibold">
        <MapIcon className="h-4 w-4" />
        Localisation
      </h3>
      <ButtonGroup
        options={options}
        selected={selected}
        setSelected={(value) => setSelected(value as SimulatorParams["localisation"])}
      />
    </div>
  );
}
